import { ArrowRight, Loader2 } from "lucide-react";

export function PurchaseButton({
  onClick,
  loading = false,
  label = "Purchase Now",
  size = "lg",
  fullWidth = false,
  showPrice = false,
  testId,
}) {
  const sizes = {
    sm: "px-5 py-2.5 text-sm",
    md: "px-7 py-3.5 text-sm",
    lg: "px-9 py-5 text-base",
    xl: "px-10 py-6 text-lg",
  };
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      disabled={loading}
      className={`group relative inline-flex items-center justify-center gap-2 ${sizes[size]} ${
        fullWidth ? "w-full" : ""
      } font-display font-bold uppercase tracking-[0.12em] rounded-full bg-emerald-500 text-black shadow-[0_0_30px_rgba(16,185,129,0.35)] hover:shadow-[0_0_60px_rgba(16,185,129,0.65)] hover:bg-emerald-400 active:scale-[0.98] transition-all duration-300 disabled:opacity-70 disabled:cursor-wait`}
    >
      <span className="relative z-10">
        {loading ? "Redirecting..." : label}
        {showPrice && !loading && (
          <span className="ml-2 opacity-80">— $95</span>
        )}
      </span>
      {loading ? (
        <Loader2 className="w-4 h-4 animate-spin relative z-10" />
      ) : (
        <ArrowRight className="w-4 h-4 relative z-10 group-hover:translate-x-1 transition-transform" />
      )}
    </button>
  );
}
